import Vue from 'vue'
import Router from 'vue-router'
import AuthRequired from '@/utils/auth-required';
import { checkServerVersion } from "@/utils";
// import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      beforeEnter: AuthRequired,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/pages/Home/index.vue'),
          meta: {
            breadcrumb: [
              { title: { i18n: 'sections.home.title', default: "Home" }, url: '/', active: true }
            ],
            pageTitle: 'sections.home.title',
          }
        },
        {
          name: "/e-learning",
          path: "/e-learning",
          component: () => import('./views/pages/E-Learning/index.vue'),
          children: [
            {
              name: "class-overview",
              path: "class-overview/:studentEnrollDetailId",
              props: true,
              component: () => import('./views/pages/E-Learning/ClassOverview/index.vue'),
              meta: {
                breadcrumb: [
                  {
                    title: {
                      i18n: 'sections.home.title', default: "Class Overview"
                    },
                    url: '/',
                    active: true
                  }
                ],
                pageTitle: 'class-overview.title',
              }
            },
          ]
        },
        {
          path: '/liveschedule',
          name: 'liveschedule',
          component: () => import('./views/pages/LiveSchedule/index.vue'),
          meta: {
            breadcrumb: [
              { title: { i18n: 'sections.liveschedule.title', default: "Live Schedule" }, url: '/', active: true }
            ],
            pageTitle: 'sections.liveschedule.title',
          }
        },
        {
          path: '/advisor-online-schedule',
          name: 'advisor-online-schedule',
          component: () => import('./views/pages/AdvisorOnlineSchedule/index.vue'),
          meta: {
            breadcrumb: [
              { title: { i18n: 'sections.advisor-online-schedule.title', default: "ตารางพบอาจรย์" }, url: '/', active: true }
            ],
            pageTitle: 'sections.advisor-online-schedule.title',
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/pages/Profile/index.vue'),
          meta: {
            breadcrumb: [
              { title: { i18n: 'sections.profile.title', default: "Profile" }, url: '/', active: true }
            ],
            pageTitle: 'sections.profile.title',
          }
        },
        {
          path: '/pm',
          name: 'pm',
          component: () => import('./views/pages/PM/index.vue'),
          meta: {
            breadcrumb: [
              { title: { i18n: 'sections.pm.title', default: "ข้อความ" }, url: '/', active: true }
            ],
            pageTitle: 'sections.pm.title',
          }
        },
        {
          path: '/university-news',
          name: 'university-news',
          component: () => import('./views/pages/UniversityNews/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              { title: { i18n: 'sections.university-news.title', default: "ข่าวสาร" }, active: true }
            ],
            pageTitle: 'sections.university-news.title',
          }
        },
        {
          path: 'info-topic-content/:id',
          name: 'info-topic-content',
          props: true,
          component: () => import('./views/pages/UniversityNews/InfoTopicContent'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.university-news.title', default: "ข่าวสาร"}, url: "/university-news/info-topic"},
              {title: {i18n: 'sections.university-news.info-topic-content.title', default: "เนื้อหาข่าวสาร"}, active: true}
            ],
            pageTitle: 'sections.university-news.info-topic-content.title',
          },
        },
      ],
    },
    // =============================================================================
    // IMMERSIVE LAYOUT ROUTES
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/immerse/Immerse.vue'),
      // redirect: '/',
      // beforeEnter: AuthRequired,
      children: [
        {
          name: "virtual-class",
          path: "/e-learning/virtual-class/:studentEnrollDetailId",
          props: true,
          component: () => import('./views/pages/E-Learning/VirtualClass/index.vue'),
          breadcrumb: [
            { title: { i18n: 'sections.home.title', default: "Home" }, url: '/', active: true }
          ],
          pageTitle: 'Home',
        },
        {
          name: "live-class",
          path: "/e-learning/live-class",
          component: () => import('./views/pages/E-Learning/LiveClass/index.vue'),
          breadcrumb: [
            { title: { i18n: 'sections.home.title', default: "Home" }, url: '/', active: true }
          ],
          pageTitle: 'Home',
        },
      ]
    },
    {
      name: "post",
      path: "/post/:id",
      component: () => import('./views/pages/E-Learning/VirtualClass/BottomPanel/WebBoard/Post'),
      breadcrumb: [
        { title: { i18n: 'sections.e-learning.web-board.title', default: "เว็บ บอร์ด" }, url: '/', active: true }
      ],
      pageTitle: 'sections.e-learning.web-board.title'
    },
    // =============================================================================
    // SECTION LAYOUT ROUTES
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      // redirect: '/',
      // beforeEnter: AuthRequired,
      children: [

      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/user',
          name: 'user',
          component: () => import('@/views/user'),
          redirect: '/user/login',
          children: [
            {
              path: 'login',
              name: 'user-login',
              component: () => import('@/views/user/Login')
            },
            {
              path: 'register',
              name: 'user-register',
              component: () => import('@/views/user/Register')
            },
            {
              path: 'forgot-password',
              name: 'user-forgot-password',
              component: () => import('@/views/user/ForgotPassword')
            },
            {
              path: 'change-password',
              name: 'user-change-password',
              props: true,
              component: () => import('@/views/user/ChangePassword')
            }
          ]
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/app-crash',
          name: 'app-crash',
          component: () => import('@/views/pages/Error500.vue')
        },
      ]
    },
    // =============================================================================
    // Development & Full Debug Pages
    // =============================================================================
    {
      path: '/dev',
      component: () => import('./layouts/dev/Main.vue'),
      // beforeEnter: AuthRequired,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'dev-main',
          component: () => import('./views/developing/Main/index.vue'),
          meta: {
            breadcrumb: [
              { title: { i18n: 'sections.home.title', default: "Home" }, url: '/', active: true }
            ],
            pageTitle: 'Home',
          }
        },
      ]
    },
    // =============================================================================
    // Fallback & Error Pages
    // =============================================================================

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

// eslint-disable-line no-unused-vars
router.beforeEach(async (from, to, next) => {
  //reload if not the same version as server
  const correctVersion = await checkServerVersion();
  if(correctVersion){
    next();
  }else{
    location.reload();
  }
});

export default router
